import React, {useState, useEffect} from "react";
import {Translation} from 'react-i18next';
import {Form, Input} from 'antd';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.bubble.css';

export default function DescriptionInput({name, label, form, defaultValue='', placeholder=null, reset=null, ...props}) {
  const [value, setValue] = useState(defaultValue);

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue, setValue]);

  // allow parent to clear contents by changing `reset` to some random value
  useEffect(() => {
    if (reset) {
      setValue('');
    }
  }, [reset, setValue]);

  return (
    <Translation>{(t) => 
      <div className="form-group">

        <Form.Item name={name} style={{display: 'none'}} {...props}>
          <Input type="hidden" />
        </Form.Item>

        <Form.Item label={label}>
          <ReactQuill
            theme="bubble"
            value={value}
            onChange={(content, delta, source, editor) => {
              setValue(content);
              form.setFields([{
                name: [name],
                value: editor.getHTML()
              }]);
            }}
            placeholder={placeholder}
          />
        </Form.Item>

      </div>
    }</Translation>
  );
}
